// ============================================================
// NUTRIMOVE LAB — Configurazione centrale del sito
// Modifica questo file per aggiornare testi di contatto, URL di
// prenotazione, numero WhatsApp e immagini. Nessun altro file
// deve essere toccato per questi aggiornamenti.
// ============================================================

export const SITE = {
  brand: "Nutrimove Lab",
  city: "Bologna",
  // Dominio canonico di produzione
  siteUrl: "https://nutrimovelab.com",
  professional: {
    name: "Dott. Michele Ceccarelli",
    role: "Biologo Nutrizionista e Dott. in Scienze Motorie",
  },

  // Prenotazioni online tramite profilo MioDottore
  bookingUrl: "https://www.miodottore.it/profilo/michele-ceccarelli",

  // Numero WhatsApp (formato internazionale, solo cifre)
  whatsappNumber: "393773310064",

  // Profilo Google Business di CASALECCHIO DI RENO — unica fonte per le recensioni
  reviewsUrl: "https://share.google/5RGhHHWxOeU69nJbK",

  contacts: {
    phone: "+39 377 3310064",
    phoneHref: "tel:+393773310064",
    email: "dr.michelececcarelli@nutrimovelab.com",
    emailHref: "mailto:dr.michelececcarelli@nutrimovelab.com",
    whatsapp: "+39 377 3310064",
    whatsappHref: "https://wa.me/393773310064",
    instagram: "@nutrimove_lab",
    instagramHref: "https://www.instagram.com/nutrimove_lab/",
  },

  // Dati legali del titolare (Nutrimove Lab è il brand)
  legal: {
    owner: "Michele Ceccarelli",
    form: "Ditta individuale",
    vat: "04202351203",
  },

  // Le tre sedi reali: 1 a Bologna, 2 a Casalecchio di Reno
  locations: [
    {
      city: "Bologna",
      lines: ["Via Scipione Dal Ferro 4", "Palazzo Dehon Media"],
      query: "Via Scipione Dal Ferro 4, Bologna, Italia",
    },
    {
      city: "Casalecchio di Reno",
      lines: ["Via XX Settembre 9", "Casalecchio di Reno (BO)"],
      query: "Via XX Settembre 9, Casalecchio di Reno, Italia",
    },
    {
      city: "Casalecchio di Reno",
      lines: ["Via Porrettana 393", "Casalecchio di Reno (BO)"],
      query: "Via Porrettana 393, Casalecchio di Reno, Italia",
    },
  ].map((loc) => ({
    ...loc,
    directions: `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(loc.query)}`,
  })),

  images: {
    logo: "/assets/nutrimove-logo.png",
    homeHero: "/assets/prima-immagine-home.webp",
    portraitHome: "/assets/doc-ceccarelli-home.webp",
    portrait: "/assets/michele-ceccarelli-professionale-cutout.webp",
    training: "/assets/allenamento-foto.webp",
    food: "/assets/nutrizione-piatti.webp",
    integrated: "/assets/allenamento-e-nutrizione.webp",
  },
};

export const whatsappLink = (message) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const WA_DEFAULT_MESSAGE =
  "Buongiorno Dott. Ceccarelli, vorrei prenotare una prima visita. Sede preferita (Bologna o Casalecchio di Reno): ____ . Disponibilità indicativa (giorni e fasce orarie): ____";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Nutrizione", to: "/nutrizione" },
  { label: "Allenamento", to: "/allenamento" },
  { label: "Integrato", to: "/nutrizione-allenamento-integrati" },
  { label: "Chi sono", to: "/chi-sono" },
  { label: "Recensioni", to: "/recensioni" },
  { label: "Contatti", to: "/contatti" },
];

export const SEO = {
  home: {
    title: "Biologo Nutrizionista e Dott. in Scienze Motorie a Bologna | Nutrimove Lab",
    description:
      "Percorsi personalizzati di nutrizione e programmazione dell'allenamento a Bologna e Casalecchio di Reno con il Dott. Michele Ceccarelli.",
  },
  nutrizione: {
    title: "Biologo Nutrizionista a Bologna | Nutrimove Lab",
    description:
      "Nutrizione personalizzata a Bologna e Casalecchio di Reno: educazione alimentare, ricomposizione corporea e nutrizione sportiva con il Dott. Michele Ceccarelli.",
  },
  integrati: {
    title: "Nutrizione e Allenamento Integrati a Bologna | Nutrimove Lab",
    description:
      "Nutrizione e programmazione dell'allenamento coordinate in un unico percorso personalizzato a Bologna e Casalecchio di Reno, con il Dott. Michele Ceccarelli.",
  },
  recensioni: {
    title: "Recensioni Pazienti | Nutrimove Lab",
    description:
      "Le recensioni reali dei pazienti di Nutrimove Lab, pubblicate su Google e consultabili sul profilo MioDottore del Dott. Michele Ceccarelli.",
  },
  allenamento: {
    title: "Allenamento Personalizzato a Bologna e Casalecchio | Nutrimove Lab",
    description:
      "Programmazione personalizzata dell'allenamento a Bologna e Casalecchio di Reno con il Dott. Michele Ceccarelli: salute, composizione corporea, forza e performance.",
  },
  chiSono: {
    title: "Dott. Michele Ceccarelli | Biologo Nutrizionista e Dott. in Scienze Motorie",
    description:
      "Formazione, iscrizione all'Ordine dei Biologi e approccio del Dott. Michele Ceccarelli: nutrizione e movimento in un'unica visione della persona.",
  },
  contatti: {
    title: "Contatti e Prenotazioni | Nutrimove Lab Bologna",
    description:
      "Prenota una visita con il Dott. Michele Ceccarelli: studi a Bologna in Via Scipione Dal Ferro 4 e a Casalecchio di Reno in Via XX Settembre 9 e Via Porrettana 393.",
  },
};
